import { connect } from 'react-redux';
import ReviewDatePicker from '../../../components/Treatments/ReviewDatePicker/ReviewDatePicker';
import { getPatternDates } from '../../../actions/areas/treatments';

const mapStateToProps = ({ areas: { treatments } }) => {
  const { isFetching, matchingDates } = treatments.patternDates;
  return {
    isFetching,
    matchingDates,
  };
};

const mapDispatchToProps = dispatch => ({
  getPatternDates: async (treatmentId, pattern, selectionMatrix, timeSlotsPackageId) =>
    await dispatch(getPatternDates(treatmentId, pattern, selectionMatrix, timeSlotsPackageId)),
});

const ReviewDatePickerContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ReviewDatePicker);

export default ReviewDatePickerContainer;
